export interface ReminderPopupInterface {
    title: string;
    titleClass?: string;
    message?: string;
    cancelText?: string;
    confirmText?: string;
    icon?: string;
}

export class ReminderPopupModel {
    title: string;
    titleClass?: string;
    message: string;
    cancelText: string;
    confirmText: string;
    icon: string;

    constructor(model: ReminderPopupInterface) {
        this.title = model.title || '';
        this.message = model.message || '';
        this.titleClass = model.titleClass || '';
        this.cancelText = model.cancelText || '';
        this.confirmText = model.confirmText || 'button.confirm';
        this.icon = model.icon || '';
    }
}
